import {
  Button,
  Input,
  SubTitle,
} from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
import { Col, Row, Spinner } from "react-bootstrap";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import {
  useActivityManagement,
  useQuestionManagement,
} from "./hooks/useActivityManagement.js";
import { Controller } from "react-hook-form";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import _ from "lodash";
import { Suspense } from "react";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import EditActivityModal from "../../Components/Modals/EditActivityModal.js";

const ActivityManagementScreen = () => {
  const {
    searchQuery,
    handleSearchChange,
    rowData,
    columns,
    indication,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    setCurrentPage,
    setPageSize,
    refetch,
    dataFetched,
    isFetching,
    isLoading,
    Modals,
    handleAddCategory,
    filterData,
    control,
    deleteModal,
    handleDeleteModalClose,
    editedData,
    deleteData,
    isDeleting,
    editModal,
    handleEditModalClose,
    categoryFilterData,
  } = useActivityManagement();

  return (
    <div className={styles.MainContainer}>
      <Modals />

      {editModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditActivityModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
            categoryData={categoryFilterData.filter(
              (cat) => cat.value !== "all"
            )}
          />
        </Suspense>
      )}
      {deleteModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            onDelete={deleteData}
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Activity Management"} classes="" />
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex justify-content-end align-items-center gap-2">
              <Input
                classes="w-50"
                type="search"
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <Controller
                control={control}
                name="category_id"
                render={({ field: { onChange, value } }) => (
                  <span className="w-50">
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "All Categories" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />
              <Button
                classes="w-50"
                text="Add Activity"
                onClick={handleAddCategory}
              ></Button>
            </div>
          </Col>
        </Row>
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords}
                totalPages={totalPages}
                pageSize={pageSize}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                refetch={refetch}
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityManagementScreen;
